import React, { useState, useEffect } from "react";
import axios from "axios";
const PromoCode = () => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [promoCodeList, setPromoCodeList] = useState([]);

  const getPromoCodeHandler = async () => {
    try{
      const res = await axios.get(`${base_url}/api/v1/home/promo-code`);
      setPromoCodeList(res.data.data);
    } catch(error) {
      console.log('error',error)
    }
  };
  useEffect(() => {
    getPromoCodeHandler();
  }, []);
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <h3>Available Offers</h3>
                <div className="table-responsive">
                  <table
                    className="table  table-bordered  shadow-sm mt-3"
                    cellPadding={5}
                  >
                    <thead>
                      <tr>
                        <th>S. No.</th>
                        <th>Promo Code</th>
                        <th>Per User Used</th>
                        <th>Description</th>
                        <th>Discount %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {promoCodeList.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.code}</td>
                              <td>{item.per_user_used}</td>
                              <td>{item.description}</td>
                              <td>{item.value}%</td>
                            </tr>
                          );
                        })}
                      {promoCodeList.length < 1 && (
                        <tr>
                          <td colSpan={5}>No record found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoCode;